import './style.css'

import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { CircleIcon } from 'components/Utils/Icons'
import IconButton from 'components/Utils/IconButton'
import { getColorMode, COLORMODES } from 'data/userPreferences/selectors'
import { providesUserPreferencesMutations } from 'components/Settings/User/dataSync'

class MetaColorMode extends React.PureComponent {
  onClick = () => {
    const newColorMode =
      this.props.colorMode === COLORMODES.DARK
        ? COLORMODES.LIGHT
        : COLORMODES.DARK

    this.props.updateUserPreferences({
      colorMode: newColorMode,
    })
  }

  render() {
    const { colorMode } = this.props
    return (
      <IconButton
        tooltip={
          colorMode === COLORMODES.DARK ? 'Set light mode' : 'Set dark mode'
        }
        tooltipPosition="left"
        onClick={this.onClick}
        className="position-relative color-mode-toggle"
      >
        <CircleIcon size={16} className="dark-part shade-20" />
        <CircleIcon size={16} className="light-part shade-30" />
      </IconButton>
    )
  }
}

export default compose(
  providesUserPreferencesMutations,
  connect(state => ({
    colorMode: getColorMode(state),
  }))
)(MetaColorMode)
